import React from 'react'
import ContactDesktop from './components/ContactDesktop'
import ContactTablet from './components/ContactTablet'
import ContactMobile from './components/ContactMobile'


const Contact: React.FC = () => {
  return (
    <>
    <div className="hidden lg:block">
        <ContactDesktop />
      </div>
      <div className="hidden md:block lg:hidden">
        <ContactTablet />
      </div>
      <div className="block md:hidden">
        <ContactMobile />
      </div>
    </>
  )
}

export default Contact